import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import apiService from '../../services/ApiService';

const DEFAULT_MAX_LENGTH = 200;
const parsedMaxLength = Number.parseInt(process.env.REACT_APP_HERO_BANNER_TEXT_MAX_LENGTH, 10);
const MAX_LENGTH = Number.isNaN(parsedMaxLength) || parsedMaxLength < 0
  ? DEFAULT_MAX_LENGTH
  : parsedMaxLength;

const HeroBannerTextPage = () => {
  const [text, setText] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const loadText = async () => {
    const [success, error] = await apiService.get('home/hero-banner-text');

    if (error) {
      toast.error('Greska pri ucitavanju hero teksta!');
      return;
    }

    setText(success?.data?.text ?? '');
  };

  const saveText = async () => {
    setIsSaving(true);
    const [success, error] = await apiService.put('home/hero-banner-text', { text });
    setIsSaving(false);

    if (error) {
      toast.error(error?.response?.data?.error?.message || 'Greska pri cuvanju hero teksta!');
      return;
    }

    setText(success?.data?.text ?? '');
    toast.success('Hero tekst je sacuvan.');
  };

  useEffect(() => {
    loadText();
  }, []);

  return (
    <div className="container mt-4">
      <h2>Hero banner tekst</h2>
      <p className="text-muted mb-3">
        Tekst moze biti i prazan. Maksimalno {MAX_LENGTH} karaktera.
      </p>

      <div className="mb-3">
        <textarea
          className="form-control"
          rows={5}
          maxLength={MAX_LENGTH}
          value={text}
          onChange={(event) => setText(event.target.value)}
          placeholder="Unesi tekst za hero banner..."
        />
        <small className="text-muted">
          {text.length}/{MAX_LENGTH}
        </small>
      </div>

      <button
        type="button"
        className="btn btn-primary"
        onClick={saveText}
        disabled={isSaving}
      >
        {isSaving ? 'Cuvanje...' : 'Sacuvaj'}
      </button>
    </div>
  );
};

export default HeroBannerTextPage;
